import { Compass } from "@/components/icons";
import { Button } from "@/components/kit";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { AlertsPanel } from "@/modules/alerts/presentation/ui/AlertsPanel";
import { useEffect } from "react";
import { useDashboardSummaryQuery } from "../api/queries";
import { DashboardTour, useDashboardTour } from "../tour/DashboardTour";
import { DashboardExploreLinks } from "../ui/DashboardExploreLinks";
import { DashboardQuickActions } from "../ui/DashboardQuickActions";
import { DashboardReportsOverview } from "../ui/DashboardReportsOverview";
import { DashboardSalesSection } from "../ui/DashboardSalesSection";
import { DashboardStats } from "../ui/DashboardStats";
import { RecentOrdersToday } from "../ui/RecentOrdersToday";

export function DashboardPage() {
  const summary = useDashboardSummaryQuery();
  const { run, handleJoyrideCallback, startTour, hasCompletedTour } =
    useDashboardTour();

  useEffect(() => {
    if (!hasCompletedTour) {
      const timer = window.setTimeout(() => startTour(), 600);
      return () => window.clearTimeout(timer);
    }
  }, [hasCompletedTour, startTour]);

  return (
    <>
      <Header />
      <Main className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-5 overflow-x-hidden">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex flex-col gap-1">
            <h2 className="font-display text-2xl text-foreground sm:text-3xl">
              ແຜງຄວບຄຸມ
            </h2>
            <p className="text-muted-foreground text-sm">
              ພາບລວມວັນນີ້ ແລະ 7 ວັນລ່າສຸດ — ເລືອກສິ່ງທີ່ຕ້ອງເຮັດກ່ອນ
            </p>
            <div className="mt-2 h-0.5 w-16 rounded-full bg-secondary/70" />
          </div>
          <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto sm:justify-end">
            <Button
              variant="outline"
              className="rounded-full"
              onClick={startTour}
            >
              <Compass />
              ທົວແນະນຳ
            </Button>
            <DashboardQuickActions />
          </div>
        </div>

        <DashboardStats summary={summary.data} isLoading={summary.isLoading} />

        <div className="grid gap-5 lg:grid-cols-12 lg:items-start">
          <div className="flex min-w-0 flex-col gap-5 lg:col-span-8">
            <DashboardReportsOverview />
            <DashboardSalesSection
              summary={summary.data}
              isLoading={summary.isLoading}
            />
          </div>

          <aside className="flex min-w-0 flex-col gap-5 lg:col-span-4">
            <section className="brand-card flex flex-col gap-3 p-4 sm:p-5">
              <div>
                <h3 className="font-display text-lg">ຕ້ອງເຮັດ</h3>
                <p className="text-muted-foreground text-sm">
                  ສິ່ງທີ່ຄວນແກ້ກ່ອນ
                </p>
              </div>
              <AlertsPanel limit={5} embedded />
            </section>

            <RecentOrdersToday
              orders={summary.data?.recentOrders?.slice(0, 5)}
              isLoading={summary.isLoading}
              className="flex-1"
            />
          </aside>
        </div>

        <DashboardExploreLinks />
      </Main>
      <DashboardTour run={run} onCallback={handleJoyrideCallback} />
    </>
  );
}
